// /boards DataGrid 컬럼 정의.
// flex 전면 제거 → width + minWidth 고정(레이아웃 결정성 확보, 헤더 잘림 해결).
// 넘치는 컬럼은 그리드 내부 가로 스크롤로 처리된다.

import type { GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import { EditButton } from "@refinedev/mui";
import { StatusChip } from "components/list";
import { IBoard } from "../interfaces";
import { boardKindMeta, resolveStatusMeta } from "./boardsStatus";

export const boardsColumns: GridColDef<IBoard>[] = [
  {
    field: "id",
    headerName: "ID",
    type: "number",
    width: 84,
    minWidth: 72,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "name",
    headerName: "게시판이름",
    type: "string",
    width: 280,
    minWidth: 160,
  },
  {
    field: "boardKind",
    headerName: "유형",
    type: "string",
    width: 104,
    minWidth: 88,
    align: "center",
    headerAlign: "center",
    renderCell: (params: GridRenderCellParams) => {
      const meta = resolveStatusMeta(boardKindMeta, params.value);
      return <StatusChip label={meta.label} color={meta.color} />;
    },
  },
  {
    field: "centerId",
    headerName: "시설ID",
    type: "string",
    width: 100,
    minWidth: 88,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "updatedDate",
    headerName: "수정일",
    type: "string",
    width: 236,
    minWidth: 190,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "actions",
    headerName: "Actions",
    width: 100,
    minWidth: 90,
    sortable: false,
    renderCell: (params: GridRenderCellParams) => (
      <EditButton hideText recordItemId={params.row.id} />
    ),
  },
];
